import * as React from 'react';
import Box from '@mui/material/Box';
import CircularProgress, {circularProgressClasses,} from '@mui/material/CircularProgress';

type SpinnerProps = {
    message?: string;
    mini?: boolean;
    rest?: object; // If "rest" has a known shape, type it accordingly instead of using generic 'object' type
};

export default function Spinner({message, mini, ...rest}: SpinnerProps) {
    const size = mini ? 20 : 40;


    return (
            <>
                {message && <Box>{message}</Box>}
                <Box sx={{position: 'relative',}}>
                    <CircularProgress
                            variant="determinate"
                            sx={{
                                color: (theme) =>
                                        theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
                            }}
                            size={size}
                            thickness={4}
                            {...rest}
                            value={100}
                    />
                    <CircularProgress
                            variant="indeterminate"
                            disableShrink
                            sx={{
                                color: (theme) => (theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8'),
                                animationDuration: '550ms',
                                position: 'absolute',
                                left: 0,
                                [`& .${circularProgressClasses.circle}`]: {
                                    strokeLinecap: 'round',
                                },
                            }}
                            size={size}
                            thickness={4}
                            {...rest}
                    />
                </Box>
            </>

    );
}
